import { RootState } from './state'

const TOGGLE_LOADING = (state: RootState, payload: Boolean) => {
  state.isLoading = payload
}

const TOGGLE_SEARCH_CONTENT = (state: RootState, payload: Boolean) => {
  state.isSearchContent = payload
}

const TOGGLE_USER_HEADER = (state: RootState, payload: Boolean) => {
  state.isShowUserHeader = payload
}

const TOGGLE_SIDEBAR_CONTENT_HEADER = (state: RootState, payload: Boolean) => {
  state.isShowSideBarContent = payload
}

const TOGGLE_NAVIGATION_BAR = (state: RootState, payload: Boolean) => {
  state.isShowNavigationBar = payload
}

const SET_CURRENT_SKILL = (state: RootState, payload: object) => {
  state.currentSkill = payload
}

const SET_CURRENT_SP_PAGE = (state: RootState, payload: object) => {
  state.currentSpPage = payload
}

const SET_SCROLL_HISTORY = (state: RootState, payload: number) => {
  state.scrollHistory = payload
}

const SET_STATE = (state: RootState, payload: { key: string; value: any }) => {
  state[payload.key] = payload.value
}

const SET_REFRESH_QUESTION_COUNT = (state: RootState, payload: boolean) => {
  state.isRefreshQuestionCount = payload
}

export default {
  TOGGLE_LOADING,
  SET_CURRENT_SKILL,
  SET_CURRENT_SP_PAGE,
  TOGGLE_SEARCH_CONTENT,
  TOGGLE_USER_HEADER,
  TOGGLE_SIDEBAR_CONTENT_HEADER,
  TOGGLE_NAVIGATION_BAR,
  SET_SCROLL_HISTORY,
  SET_STATE,
  SET_REFRESH_QUESTION_COUNT
}
